import React from 'react';
import PropTypes from 'prop-types';
import ReactTable from "../../Components/ReactTable";

const TotalsSearchResults = ({
                                 pageSize = 10,
                                 updatePageSize = () => {},
                                 columns = [],
                                 data,
                                 defaultSortedId,
                                 trClassName = '',
                                 reactTableXCoordinateRef,
                                 meta
                             }) => (
    <div id={'totals-data'}>
        <ReactTable
            columns={columns}
            data={data}
            updatePageSize={updatePageSize}
            filterable
            initialState={{sorting: [{id: defaultSortedId, desc: true}], pagination: {pageSize}}}
            hasStickyHeader={true}
            trClassName={trClassName}
            reactTableXCoordinateRef={reactTableXCoordinateRef}
            savePageIndexToUrl={true}
            meta={meta}
        />
    </div>
);
TotalsSearchResults.propTypes = {
    data: PropTypes.array,
    pageSize: PropTypes.number,
    updatePageSize: PropTypes.func,
    defaultSortedId: PropTypes.string,
    trClassName: PropTypes.string,
    reactTableXCoordinateRef: PropTypes.any,
    meta: PropTypes.object
};

export default TotalsSearchResults;